/**
 * Worker (PWA) auth — `POST /api/field/auth/login` (see backend §1.4 and
 * `api/routers/worker_auth.py`).  Reuses the shared `apiFetch` so the
 * existing session cookie / CSRF double-submit flow stays in one place.
 *
 * Error shapes we surface to the UI (mirrors backend semantics):
 *   - 401 `invalid_credentials`  → wrong tab/PIN, allow retry
 *   - 403 `account_disabled`     → terminal toast, no retry
 *   - 423 `account_locked`       → lockout body inside PinSheet,
 *                                  `detail.locked_until` is ISO datetime
 */
import { api } from "./client";
import type { components } from "./types";
import type { User } from "./auth";

export type WorkerLoginRequest = components["schemas"]["WorkerLoginRequest"];

export async function workerLogin(payload: WorkerLoginRequest): Promise<User> {
  return api.post<User>("/field/auth/login", payload);
}
